/**
 * Shared helpers for service-directory SEO landings.
 * Prefer server-provided categorySlug/companySlug when present so client and API stay in sync.
 */
import { slugify, companySlug } from '@/utils/slugify'

export function enrichServiceListings(listings = []) {
  const nameIdPairs = listings.map((item) => ({ name: item.name, id: item.id }))

  return listings.map((item) => {
    const categorySlug = item.categorySlug || slugify(item.catName)
    const slug = item.companySlug || companySlug(item.name, item.id, nameIdPairs)
    return {
      ...item,
      categorySlug,
      companySlug: slug,
      categoryHref: `/services/${categorySlug}`,
      companyHref: `/services/${categorySlug}/${slug}`,
    }
  })
}

export function groupServicesByCategory(listings = []) {
  const enriched = enrichServiceListings(listings)
  const byCat = {}

  enriched.forEach((item) => {
    if (!byCat[item.catName]) {
      byCat[item.catName] = {
        catName: item.catName,
        catId: item.catId,
        categorySlug: item.categorySlug,
        imgName: item.imgName,
        href: item.categoryHref,
        companies: [],
      }
    }
    byCat[item.catName].companies.push(item)
  })

  return Object.values(byCat).sort((a, b) => a.catName.localeCompare(b.catName))
}
